import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    margin: theme.spacing(-2, 0, 7.51, 0),
  },
  description: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.labraText.primary,
  },
  content: {
    marginTop: theme.spacing(4),
  },
  horizontalDivider: {
    borderTop: `1px solid ${theme.palette.dividerV2.main}`,
    borderRadius: theme.spacing(0.5),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
}))
